











import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

import { Pricing } from "@/shared/interfaces/pricing/pricing.interface";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },

    props: {
        packs: {
            type: Array,
            required: true,
        },
    },

    computed: {
        options: function() {
            const packs = this.packs as Pricing[];
            return packs.map(({ duration, id }) => ({
                "label": `${this.pluralization(`x_${duration.unit.toLowerCase()}s`, duration.count)}`,
                "value": id,
            }));
        },
    },

    methods: {
        selectDuration: function (duration: string) {
            this.$emit("duration-select", duration);
        },
    }
});
